module.exports = __webpack_public_path__ + "img/icon3.82abc9fa.png";